import { Card, Chip } from "@mui/material";
import { useState, useEffect } from "react";
import DataTable from "../../../../../Components/Table/DataTable";
import WDBox from "../../../../../MaterialComponents/WDBox";
import AppService from "../../../../../Configurations/Appservice";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateScreenTitle } from "../../../../../LayoutContainers/AppLayout/redux/AppSlice";

const tableInitialData = {
  columns: [
    { Header: "Ticket Number", accessor: "ticketNumber" },
    { Header: "Service", accessor: "service" },
    { Header: "Created By", accessor: "createdBy" },
    { Header: "Custome Organisation", accessor: "customerOrganisation" },
    { Header: "Pending At", accessor: "pendingAt" },
    { Header: "Status", accessor: "status" },
    { Header: "Created date", accessor: "createdDate" },
    { Header: "View", accessor: "view", width: "10%" },
  ],
  rows: [],
};

const tableFilters = [
  {
    accessor: "service",
    type: "LIST",
    labelName: "Service",
  },
  {
    accessor: "ticketNumber",
    type: "TEXT",
    labelName: "Ticket Number",
  },
];

const PendingPartnerTickets = () => {
  const [tableData, setTableData] = useState(tableInitialData);
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Pending Partner Tickets"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    if (location?.state?.ticket) {
      tableFilters.forEach((filter) => {
        if (filter.accessor === "service") {
          filter.defaultValue = location.state.ticket.serviceName;
        }
      });
    }

    AppService.get("v1/ticket/pendingPartnerTickets")
      .then((response) => {
        _generateRows(response);
      })
      .catch((error) => {
        alert("error");
      })
      .finally(() => {});
  }, []);

  const _navigateToDetails = (ticketId) => {
    navigate("/ADM-Ticket/ticket-details", {
      state: {
        ticketId,
      },
    });
  };

  const _generateRows = (data) => {
    let rows = data.map((item) => ({
      ticketNumber: item.ticketNumber,
      service: item.serviceName,
      createdBy: item.createdBy,
      status: <Chip size="small" label={item.status} color="primary" variant="outlined" />,
      statusSearch: item.status,
      createdDate: moment.utc(item.createdAt).local().format("YYYY-MM-DD"),
      view: <VisibilityOutlinedIcon onClick={() => _navigateToDetails(item.id)} />,
      ...item,
    }));
    let tableDataCopy = { ...tableData };
    tableDataCopy.rows = rows;
    setTableData(tableDataCopy);
  };

  return (
    <WDBox>
      <Card>
        {tableData.rows.length && <DataTable table={tableData} tableFilters={tableFilters} />}
      </Card>
    </WDBox>
  );
};

export default PendingPartnerTickets;
